<script setup>
import { ref, watch } from 'vue'
import { commerceSettingsApi } from '@/api/modules/commerceSettings.js'
const props = defineProps({ modelValue: { type: String, default: '' }, type: { type: String, required: true } })
const emit = defineEmits(['update:modelValue'])
const options = ref([])
const error = ref('')
let serial = 0
watch(() => props.type, async type => {
  const request = ++serial
  error.value = ''; options.value = []
  try {
    const res = type === 'category' ? await commerceSettingsApi.listContentCategories()
      : type === 'hall' ? await commerceSettingsApi.listHalls() : await commerceSettingsApi.listPages()
    if (request !== serial) return
    const rows = Array.isArray(res.data) ? res.data : (res.data?.items || [])
    options.value = rows.map(row => ({ value: row.slug || row.storefrontSlug || row.storefront_slug || row.id, label: row.name || row.title }))
  } catch { if (request === serial) error.value = '無法載入選項，請重新開啟此頁' }
}, { immediate: true })
</script>
<template>
  <select class="form-control form-control-sm" :value="modelValue" :aria-label="type === 'category' ? '選擇商品分類' : type === 'hall' ? '選擇館別' : '選擇內容頁'" @change="emit('update:modelValue', $event.target.value)">
    <option value="">請選擇</option>
    <option v-if="modelValue && !options.some(o => o.value === modelValue)" :value="modelValue">目前項目（{{ modelValue }}）</option>
    <option v-for="item in options" :key="item.value" :value="item.value">{{ item.label }}</option>
  </select>
  <p v-if="error" role="alert">{{ error }}</p>
</template>
